export const formatBytes = (bytes: number, decimals = 2) => {
  if (!+bytes) {
    return '0 Bytes'
  }

  const kilobytes = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const sizeIndex = Math.floor(Math.log(bytes) / Math.log(kilobytes))

  return `${parseFloat((bytes / Math.pow(kilobytes, sizeIndex)).toFixed(dm))} ${sizes[sizeIndex]}`
}
